export const tasks = [
  {
    name: 'main',
    handle() {
      return new Promise(resolve => {
        // setTimeout(() => {
        //   console.log('首页需要的执行');
        //   resolve();
        // }, 3000);
        resolve();
      });
    }
  }
];



// WEBPACK FOOTER //
// ./src/pages/home/hall/index.js